import { enumItems } from 'lib/enumItems';
import { TZUtils } from 'lib/tzutils';
import TZDate from 'lib/TZDate';
import { tzmoment } from 'lib/tzmoment';
import { PortCallUserRole, PortCallUserRoleDisplayName, PortCallUserRoles } from 'server/enums/PortCallUserRole';

// Standard utilities for parsing/serializing query string params

export function parsePortCallUserRole(role : string) {
    role = role.toLowerCase();
    for (let i = 0; i < PortCallUserRoles.length; i++) {
        if (role === PortCallUserRoleDisplayName[PortCallUserRoles[i].Id].toLowerCase()) {
            return PortCallUserRoles[i].Id;
        }
    }
    throw new Error('Unknown role string: ' + role);
}

export function parseDate(str : string, tzutils : TZUtils) {
    return tzutils.setTimezoneOffset(new TZDate(str + 'T00:00:00Z'), true);
}

export function serializeDate(date : TZDate) {
    return tzmoment(date).format('YYYY-MM-DD');
}


// WEBPACK FOOTER //
// ./apps/common/services/routeParams.ts